<template>
  <b-form-textarea
    v-model="localValue"
    :id="id"
    :aria-invalid="ariaInvalid"
    :autocomplete="autocomplete"
    :autofocus="autofocus"
    :debounce="debounce"
    :disabled="disabled"
    :form="form"
    :formatter="formatter"
    :lazy="lazy"
    :lazy-formatter="lazyFormatter"
    :max-rows="maxRows"
    :name="name"
    :no-auto-shrink="noAutoShrink"
    :no-resize="noResize"
    :number="number"
    :placeholder="placeholder"
    :plaintext="plaintext"
    :readonly="readonly"
    :required="required"
    :rows="rows"
    :size="size"
    :state="state"
    :trim="trim"
    :wrap="wrap"
  />
</template>

<script>
import { BFormTextarea } from 'bootstrap-vue';

export default {
  name: 'MFormTextarea',
  components: {
    BFormTextarea,
  },
  props: {
    ariaInvalid: {
      type: [String, Boolean],
      default: false,
    },
    autocomplete: {
      type: String,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    debounce: {
      type: [Number, String],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    form: {
      type: String,
      default: null,
    },
    /* eslint-disable vue/require-default-prop */
    formatter: {
      type: Function,
    },
    /* eslint-enable vue/require-default-prop */
    id: {
      type: String,
      default: null,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    lazyFormatter: {
      type: Boolean,
      default: false,
    },
    maxRows: {
      type: [Number, String],
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    noAutoShrink: {
      type: Boolean,
      default: false,
    },
    noResize: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    plaintext: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: [Number, String],
      default: 20,
    },
    size: {
      type: String,
      default: null,
    },
    state: {
      type: Boolean,
      default: null,
    },
    trim: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    wrap: {
      type: String,
      default: 'soft',
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
    localValue(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>
